function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "sp-scans_svg__a",
  maskUnits: "userSpaceOnUse",
  x: 7,
  y: 15,
  width: 21,
  height: 13
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.563 22.447l-7.44-4.296a1.65 1.65 0 01-.826-1.43V27.94H27.13V16.722a1.65 1.65 0 01-.825 1.43l-7.442 4.295a3.3 3.3 0 01-3.3 0z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.679 15.462l-7.815 4.51a3.301 3.301 0 01-3.3 0l-7.815-4.51c.05.037.104.072.162.105l7.874 4.546c.789.456 2.069.456 2.858 0l7.874-4.546c.058-.033.112-.068.162-.105z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.517 15.567c.058-.033.112-.068.162-.105l-7.815 4.51a3.301 3.301 0 01-3.3 0l-7.815-4.51c.05.037.104.072.162.105l7.874 4.546c.789.456 2.069.456 2.858 0l7.874-4.546z",
  fill: "#fff"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#sp-scans_svg__a)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 12.393,
  height: 12.393,
  rx: 1.65,
  transform: "matrix(.86603 .5 -.86603 .5 17.214 13.547)",
  fill: "url(#sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__paint0_scans_icon_menu)"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M18.864 27.448c-1.021.59-2.28.59-3.3 0l-7.442-4.296a1.65 1.65 0 01-.825-1.43v-1.968a.86.86 0 00.388.672l7.879 4.547a3.3 3.3 0 003.3 0l7.879-4.547a.858.858 0 00.388-.672v1.968a1.65 1.65 0 01-.825 1.43l-7.442 4.296z",
  fill: "url(#sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__paint1_scans_icon_menu)"
}), /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  width: 7,
  height: 0.5,
  rx: 0.25,
  transform: "matrix(.86603 .5 0 1 9.353 22.44)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  opacity: 0.7,
  width: 0.757,
  height: 0.5,
  rx: 0.25,
  transform: "matrix(.86603 .5 0 1 8.243 21.69)",
  fill: "#fff"
}));

var _ref4 = /*#__PURE__*/React.createElement("mask", {
  id: "sp-scans_svg__b",
  maskUnits: "userSpaceOnUse",
  x: 7,
  y: 10,
  width: 21,
  height: 13
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.563 17.479l-7.44-4.297a1.65 1.65 0 01-.826-1.429v11.218H27.13V11.753a1.65 1.65 0 01-.825 1.43l-7.442 4.296c-1.021.59-2.28.59-3.3 0z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.679 10.493l-7.815 4.51a3.3 3.3 0 01-3.3 0l-7.815-4.51c.05.037.104.072.162.106l7.874 4.546c.789.455 2.069.455 2.858 0l7.874-4.546a1.77 1.77 0 00.162-.106z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.517 10.599a1.77 1.77 0 00.162-.106l-7.815 4.51a3.3 3.3 0 01-3.3 0l-7.815-4.51c.05.037.104.072.162.106l7.874 4.546c.789.455 2.069.455 2.858 0l7.874-4.546z",
  fill: "#fff"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#sp-scans_svg__b)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 12.393,
  height: 12.393,
  rx: 1.65,
  transform: "matrix(.86603 .5 -.86603 .5 17.214 8.546)",
  fill: "url(#sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__paint2_scans_icon_menu)"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M18.864 22.447a3.3 3.3 0 01-3.3 0l-7.442-4.296a1.65 1.65 0 01-.825-1.43v-1.968c0 .248.174.549.388.672l7.879 4.547c1.021.59 2.279.59 3.3 0l7.879-4.547a.858.858 0 00.388-.672v1.969a1.65 1.65 0 01-.825 1.43l-7.442 4.295z",
  fill: "url(#sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__paint3_scans_icon_menu)"
}), /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  width: 7,
  height: 0.5,
  rx: 0.25,
  transform: "matrix(.86603 .5 0 1 9.353 17.439)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  opacity: 0.7,
  width: 0.757,
  height: 0.5,
  rx: 0.25,
  transform: "matrix(.86603 .5 0 1 8.243 16.689)",
  fill: "#fff"
}));

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  width: 12.393,
  height: 12.393,
  rx: 1.65,
  transform: "matrix(.86603 .5 -.86603 .5 17.214 3.545)",
  fill: "url(#sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__paint4_scans_icon_menu)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M18.864 17.447c-1.021.59-2.28.59-3.3 0L8.121 13.15a1.65 1.65 0 01-.825-1.429V9.752c0 .248.174.549.388.672l7.879 4.548a3.3 3.3 0 003.3 0l7.879-4.548a.857.857 0 00.388-.672v1.969a1.65 1.65 0 01-.825 1.43l-7.442 4.296z",
  fill: "url(#sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__paint5_scans_icon_menu)"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  width: 7,
  height: 0.5,
  rx: 0.25,
  transform: "matrix(.86603 .5 0 1 9.353 12.438)",
  fill: "#fff"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.7,
  width: 0.757,
  height: 0.5,
  rx: 0.25,
  transform: "matrix(.86603 .5 0 1 8.243 11.688)",
  fill: "#fff"
});

var _ref10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__paint0_scans_icon_menu",
  x1: 14.333,
  y1: 1.94,
  x2: 2.482,
  y2: 17.247,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__paint1_scans_icon_menu",
  x1: 27.131,
  y1: 21.359,
  x2: 15.961,
  y2: 21.359,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__paint2_scans_icon_menu",
  x1: 14.333,
  y1: 1.94,
  x2: 2.482,
  y2: 17.247,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__paint3_scans_icon_menu",
  x1: 27.131,
  y1: 16.358,
  x2: 15.961,
  y2: 16.358,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__paint4_scans_icon_menu",
  x1: 14.333,
  y1: 1.94,
  x2: 2.482,
  y2: 17.247,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__sp-scans_svg__paint5_scans_icon_menu",
  x1: 27.131,
  y1: 11.358,
  x2: 15.961,
  y2: 11.358,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})));

var SvgSpScans = function SvgSpScans(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 30,
    fill: "none",
    viewBox: "0 3 30 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSpScans, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sp-scans.e805ffca.svg";
export { ForwardRef as ReactComponent };